import { render, staticRenderFns } from "./ButtonLayout.vue?vue&type=template&id=79251208"
import script from "./ButtonLayout.vue?vue&type=script&lang=js"
export * from "./ButtonLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports